
import Top from "../components/Top";
import styles from "../style.module.css";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_URL } from "../api/config";
import Spinner from 'react-bootstrap/Spinner';

function Contact() {
  const { isLoading, isError, data, error } = useQuery({
    queryKey: ['contact-page'],
    queryFn: async () => {
      const res = await fetch(`${API_BASE_URL}/api/user/pages/contact`);
      return await res.json();
    },
  })

  if (isLoading) {
    return <div className="d-flex flex-column justify-content-center justify-content-center align-items-center" style={{ height: "50vh" }}>
      <Spinner animation="border" role="status" style={{ height: "89px", width: "89px" }}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      <p className="mt-3">Kindly be patient while we fetch your data</p>
    </div>
  }

  if (isError) {
    return (
      <p>An Error Occurred : {error.message}</p>
    )
  }


  return (
    <div className={styles.contact}>
      <div className={`container ${styles.contactContent}`}>
        <h6 className={`text-center ${styles.pres}`}>Contact</h6>
        <h3 className={`text-center ${styles.headText2}`}>
          Get in Touch with Us
        </h3>
        <div className="row">
          <div className={`col-12 col-md-6 col-lg-4 ${styles.contactItems}`}>
            <div className={`card ${styles.card}`}>
              <div className={styles.contactIcon}>
                <i className="fa fa-map"></i>
              </div>
              <div className={styles.contactText}>
                <h6>Our Address</h6>
                {
                  data?.metadata["Our Address"].map(a => <p key={a}>{a}</p>)
                }
              </div>
            </div>
          </div>

          <div className={`col-12 col-md-6 col-lg-4 ${styles.contactItems}`}>
            <div className={`card ${styles.card}`}>
              <div className={styles.contactIcon}>
                <i className="fa fa-envelope"></i>
              </div>
              <div className={styles.contactText}>
                <h6>Email</h6>
                <p>
                  <a href={`mailto:${data?.metadata?.email}`}>{data?.metadata?.email}</a>
                </p>
              </div>
            </div>
          </div>

          <div className={`col-12 col-md-6 col-lg-4 ${styles.contactItems}`}>
            <div className={`card ${styles.card}`}>
              <div className={styles.contactIcon}>
                <i className="fa fa-headphones"></i>
              </div>
              <div className={styles.contactText}>
                <h6>Give Us a Call</h6>
                <div className={styles.numbers}>
                  {
                    data?.metadata["Our AddressGive Us a Call"].map(a => <div key={a}>{a}</div>)
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.support}>
          <h6 className={`text-center ${styles.pres}`}>Support</h6>
          <h3
            className={`text-center ${styles.headText2}`}
            style={{ lineHeight: "15px" }}
          >
            Let's talk
          </h3>
          <h6 className={`text-center ${styles.supportExp}`}>
            If you have a question regarding our services, feel free to contact
            us using the form below
          </h6>
          <form className={styles.supportForm}>
            <div className="form-group">
              <div className="row">
                <div className="col-12 col-md-6">
                  <input
                    type="text"
                    className={`form-control ${styles.formName}`}
                    placeholder="Enter your name"
                    required
                  />
                </div>
                <div className="col-12 col-md-6">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter email"
                    required
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12">
                  <input
                    type="text"
                    placeholder="Enter subject"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12">
                  <textarea
                    className="form-control"
                    placeholder="Type your message"
                    rows="5"
                  ></textarea>
                </div>
              </div>
              <div className="text-center">
                <button className={styles.regBtn}>Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <Top />
    </div>
  );
}

export default Contact;
